var _g, _g2, _circle, _circle2, _g3, _circle3, _g4, _line, _line2, _line3, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorTickLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_262_1",
    "data-name": "Component 262 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.125,
    height: 101.953,
    viewBox: "0 0 130.125 101.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Path_15974",
    "data-name": "Path 15974",
    d: "M660.76,201a30.854,30.854,0,0,0,16.538-4.96,30.136,30.136,0,0,0,9.929-10.754,17.787,17.787,0,0,0,1.534-4.154c1.707-6.743,1.494-15.455,6.413-21.43,6.066-7.366,20.026-15.992,22.1-31.514a21.62,21.62,0,0,0-2.813-13.195,24.212,24.212,0,0,0-7.724-8.014A44.274,44.274,0,0,0,690.07,100.4a78.072,78.072,0,0,0-10.414-1.219,92.754,92.754,0,0,0-21.33,1.285c-10.694,1.925-21.27,6.03-29.153,13.511a34.8,34.8,0,0,0-4.76,5.54,38.983,38.983,0,0,0-4.065,7.954,57.3,57.3,0,0,0-3.14,11.892c-2.189,14.128.479,29.173,8.379,41.327C634.494,194.394,648.455,201.1,660.76,201Z",
    transform: "translate(-605.691 -99.047)",
    fill: "#fae8e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_14284",
    "data-name": "Path 14284",
    transform: "translate(41.809 22.907)",
    fill: "#fae8e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.53055000305176 60.06110000610352 C 26.54351043701172 60.06110000610352 22.67625999450684 59.28046035766602 19.03623008728027 57.74084854125977 C 15.5198802947998 56.25355911254883 12.36165046691895 54.12416076660156 9.649299621582031 51.41180038452148 C 6.93694019317627 48.6994514465332 4.807539939880371 45.54122161865234 3.320250034332275 42.02487182617188 C 1.780640006065369 38.38483810424805 1 34.5175895690918 1 30.53055000305176 C 1 26.54351043701172 1.780640006065369 22.67625999450684 3.320250034332275 19.03623008728027 C 4.807539939880371 15.5198802947998 6.93694019317627 12.36165046691895 9.649299621582031 9.649299621582031 C 12.36165046691895 6.93694019317627 15.5198802947998 4.807539939880371 19.03623008728027 3.320250034332275 C 22.67625999450684 1.780640006065369 26.54351043701172 1 30.53055000305176 1 C 34.5175895690918 1 38.38483810424805 1.780640006065369 42.02487182617188 3.320250034332275 C 45.54122161865234 4.807539939880371 48.6994514465332 6.93694019317627 51.41180038452148 9.649299621582031 C 54.12416076660156 12.36165046691895 56.25355911254883 15.5198802947998 57.74084854125977 19.03623008728027 C 59.28046035766602 22.67625999450684 60.06110000610352 26.54351043701172 60.06110000610352 30.53055000305176 C 60.06110000610352 34.5175895690918 59.28046035766602 38.38483810424805 57.74084854125977 42.02487182617188 C 56.25355911254883 45.54122161865234 54.12416076660156 48.6994514465332 51.41180038452148 51.41180038452148 C 48.6994514465332 54.12416076660156 45.54122161865234 56.25355911254883 42.02487182617188 57.74084854125977 C 38.38483810424805 59.28046035766602 34.5175895690918 60.06110000610352 30.53055000305176 60.06110000610352 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.53055000305176 2 C 26.67807006835938 2 22.94189071655273 2.754070281982422 19.42578125 4.241249084472656 C 16.02862930297852 5.678131103515625 12.97724151611328 7.735561370849609 10.35639953613281 10.35639953613281 C 7.735561370849609 12.97724151611328 5.678131103515625 16.02862930297852 4.241249084472656 19.42578125 C 2.754070281982422 22.94189071655273 2 26.67807006835938 2 30.53055000305176 C 2 34.38302993774414 2.754070281982422 38.11920928955078 4.241249084472656 41.63532257080078 C 5.678131103515625 45.032470703125 7.735561370849609 48.0838623046875 10.35639953613281 50.7047004699707 C 12.97724151611328 53.32553863525391 16.02862930297852 55.38296890258789 19.42578125 56.81985092163086 C 22.94189071655273 58.30702972412109 26.67807006835938 59.06110000610352 30.53055000305176 59.06110000610352 C 34.38302993774414 59.06110000610352 38.11920928955078 58.30702972412109 41.63532257080078 56.81985092163086 C 45.032470703125 55.38296890258789 48.0838623046875 53.32553863525391 50.7047004699707 50.7047004699707 C 53.32553863525391 48.0838623046875 55.38296890258789 45.032470703125 56.81985092163086 41.63532257080078 C 58.30702972412109 38.11920928955078 59.06110000610352 34.38302993774414 59.06110000610352 30.53055000305176 C 59.06110000610352 26.67807006835938 58.30702972412109 22.94189071655273 56.81985092163086 19.42578125 C 55.38296890258789 16.02862930297852 53.32553863525391 12.97724151611328 50.7047004699707 10.35639953613281 C 48.0838623046875 7.735561370849609 45.032470703125 5.678131103515625 41.63532257080078 4.241249084472656 C 38.11920928955078 2.754070281982422 34.38302993774414 2 30.53055000305176 2 M 30.53055000305176 0 C 47.39210891723633 0 61.06110000610352 13.66899108886719 61.06110000610352 30.53055000305176 C 61.06110000610352 47.39210891723633 47.39210891723633 61.06110000610352 30.53055000305176 61.06110000610352 C 13.66899108886719 61.06110000610352 0 47.39210891723633 0 30.53055000305176 C 0 13.66899108886719 13.66899108886719 0 30.53055000305176 0 Z",
    stroke: "none",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_15975",
    "data-name": "Path 15975",
    transform: "translate(38.051 20.088)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.414,0A32.414,32.414,0,1,1,0,32.414,32.414,32.414,0,0,1,32.414,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.41381072998047 2 C 28.30709075927734 2 24.32427978515625 2.803859710693359 20.57600021362305 4.389251708984375 C 16.95458221435547 5.920982360839844 13.70180130004883 8.114200592041016 10.90800094604492 10.90800094604492 C 8.114200592041016 13.70180130004883 5.920982360839844 16.95458221435547 4.389251708984375 20.57600021362305 C 2.803859710693359 24.32427978515625 2 28.30709075927734 2 32.41381072998047 C 2 36.52053070068359 2.803859710693359 40.50334930419922 4.389251708984375 44.25163269042969 C 5.920982360839844 47.87303924560547 8.114200592041016 51.12583160400391 10.90800094604492 53.91962051391602 C 13.70180130004883 56.71342086791992 16.95458221435547 58.90663909912109 20.57600021362305 60.43836975097656 C 24.32427978515625 62.02376174926758 28.30709075927734 62.82762145996094 32.41381072998047 62.82762145996094 C 36.52053070068359 62.82762145996094 40.50334930419922 62.02376174926758 44.25163269042969 60.43836975097656 C 47.87303924560547 58.90663909912109 51.12583160400391 56.71342086791992 53.91962051391602 53.91962051391602 C 56.71342086791992 51.12583160400391 58.90663909912109 47.87303924560547 60.43836975097656 44.25163269042969 C 62.02376174926758 40.50334930419922 62.82762145996094 36.52053070068359 62.82762145996094 32.41381072998047 C 62.82762145996094 28.30709075927734 62.02376174926758 24.32427978515625 60.43836975097656 20.57600021362305 C 58.90663909912109 16.95458221435547 56.71342086791992 13.70180130004883 53.91962051391602 10.90800094604492 C 51.12583160400391 8.114200592041016 47.87303924560547 5.920982360839844 44.25163269042969 4.389251708984375 C 40.50334930419922 2.803859710693359 36.52053070068359 2 32.41381072998047 2 M 32.41381072998047 0 C 50.31547164916992 0 64.82762145996094 14.51216125488281 64.82762145996094 32.41381072998047 C 64.82762145996094 50.31547164916992 50.31547164916992 64.82762145996094 32.41381072998047 64.82762145996094 C 14.51216125488281 64.82762145996094 0 50.31547164916992 0 32.41381072998047 C 0 14.51216125488281 14.51216125488281 0 32.41381072998047 0 Z",
    stroke: "none",
    fill: "#d11800"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_843",
    "data-name": "Ellipse 843",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(35.125 59)",
    fill: "#fae8e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_844",
    "data-name": "Ellipse 844",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(69.125 17)",
    fill: "#fae8e6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_845",
    "data-name": "Ellipse 845",
    transform: "translate(32.125 16)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_846",
    "data-name": "Ellipse 846",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(106.125 69)",
    fill: "#d11800"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_847",
    "data-name": "Ellipse 847",
    transform: "translate(108.125 28)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x2: 56.367,
    transform: "translate(5.637 88.674)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 21.609,
    transform: "translate(0 94.669)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 22,
    transform: "translate(108.125 22)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11413",
    "data-name": "Group 11413",
    transform: "translate(64.819 -147.65) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11964",
    "data-name": "Path 11964",
    d: "M-1676.151,16256h34.284",
    transform: "translate(1804.47 -16118.521)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11965",
    "data-name": "Path 11965",
    d: "M0,0H34.285",
    transform: "translate(145.462 120.335) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11413-2",
    "data-name": "Group 11413",
    transform: "translate(65.819 -147.65) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11964-2",
    "data-name": "Path 11964",
    d: "M-1676.151,16256h32.247",
    transform: "translate(1804.47 -16119.539)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11965-2",
    "data-name": "Path 11965",
    d: "M0,0H32.247",
    transform: "translate(144.444 120.335) rotate(90)",
    fill: "none",
    stroke: "#d11800",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTickLogo);
export default __webpack_public_path__ + "static/media/error-tick-logo.5928d4d2be691afb470f8cdb0f28c696.svg";
export { ForwardRef as ReactComponent };